
import React, { useState } from "react"
import { useSelector } from "react-redux";

const KPH_FACTOR = 1.609

export const useGetOdometerUserValues = () => {

    //const [isKph, setIsKph] = useState(user?.isKph)

    const user = useSelector(state => state.securityRedux.user);

    const getOdometerUnitValue = (value, isReturn = false) => {

        if (!value)
            return value

        value = Number(value)

        if (value == 0)
            return 0

        if (user.isKph) {
            if (isReturn) {
                // Keep fractional MPH so integer KPH values (e.g. 120) survive round-trip.
                // Math.round(120 / 1.609) = 75, then 75 * 1.609 displays as 121.
                return Number((value / KPH_FACTOR).toFixed(4))
            }
            return Number(Math.round(value * KPH_FACTOR)) || 1
        }

        return Number(Math.round(value)) || 1
    }


    return [getOdometerUnitValue, user.isKph ? "KPH" : "MPH"]
}
